import { FC } from "react";
import { TaxSlipSummaryDataInput } from "../../../TaxSlipSummaryDataInput";

export interface IDifferencePanel {}

export const DifferencePanel: FC<IDifferencePanel> = () => {
  return (
    <>
      <TaxSlipSummaryDataInput
        id="difference"
        label="Difference"
        boxNumber=""
      />
    </>
  );
};
